import React from "react";
import { useQuery } from "@apollo/client";
import { PRODUCT_FAQS_QUERY } from "../graphql/faqs";
import FaqAccordion from "./FaqAccordion";

type Faq = { id: string; question: string; answer: string; position: number };
type ProductFaqsData = { productFaqs: Faq[] };

type Props = {
  productId: string;
  productName: string;
};

export default function ProductFaqSection({ productId, productName }: Props) {
  const { data } = useQuery<ProductFaqsData>(PRODUCT_FAQS_QUERY, {
    variables: { productId },
    fetchPolicy: "cache-and-network",
    skip: !productId,
  });

  const faqs = data?.productFaqs ?? [];
  if (!faqs.length) return null;

  return <FaqAccordion faqs={faqs} title={`${productName} — FAQs`} />;
}
